import React, { useEffect, useState } from 'react';
import { Box, Button, Modal, TextField, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { toast } from 'react-toastify';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import { useDispatch, useSelector } from 'react-redux';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import moment from 'moment';
import { editBuzzSubscription } from '../BuzzSlice';
import BuzzMultiSelect from '../../../components/BuzzMultiSelect/BuzzMultiSelect';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import { capitalize, months } from '../../../utils/enum';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 500,
  minHeight: 145,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

function SubscriptionModal({ data, open, onClose }) {
  const { _id: subscriptionId, availableLicenseQuota } = data;

  const dispatch = useDispatch();

  const { classes, languages } = useSelector(({ akademyReducer }) => {
    return {
      classes: akademyReducer.classes,
      languages: akademyReducer.languages,
    };
  });

  const [editFormFields, setEditFormFields] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);

  const setFormData = (key, value) => {
    const newFormFields = JSON.parse(JSON.stringify(editFormFields));

    if (key.split('.').length > 1) {
      const [key1, key2] = key.split('.');
      if (!newFormFields[key1]) newFormFields[key1] = {};
      newFormFields[key1][key2] = value;
    } else newFormFields[key] = value;
    setEditFormFields(newFormFields);
  };

  useEffect(() => {
    let initialForm = {
      startDate: data.startDate,
      endDate: data.endDate,
    };

    if (data.metadata)
      initialForm = { ...initialForm, metadata: data.metadata };

    setEditFormFields(initialForm);
  }, []);

  useEffect(() => {
    return () => {
      setEditFormFields({});
      setAddedLicenseQuota({});
      setIsEditMode(false);
    };
  }, []);

  const [addedLicenseQuota, setAddedLicenseQuota] = useState({ GENERAL: 0 });

  const incrementLicenseCount = (key) => {
    setAddedLicenseQuota((state) => ({
      ...state,
      [key]: (state[key] || 0) + 1,
    }));
  };
  const decrementLicenseCount = (key) => {
    setAddedLicenseQuota((state) => ({
      ...state,
      [key]: (state[key] || 0) - 1,
    }));
  };

  const changeLicenseCount = (key, newValue) => {
    setAddedLicenseQuota((state) => ({
      ...state,
      [key]: newValue,
    }));
  };

  const handleEditSave = () => {
    dispatch(
      editBuzzSubscription({
        subscriptionId,
        data: { ...editFormFields, addedLicenseQuota },
      })
    )
      .unwrap()
      .then((res) => {
        toast.success(res.message);
        setIsEditMode(false);
        onClose();
        window.location.reload();
      });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <>
        <CloseIcon />
        <Box sx={style}>
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}>
            <Typography variant="h5">
              <Box fontWeight={'fontWeightMedium'}>Subscription Details</Box>
            </Typography>

            {isEditMode ? (
              <Box style={{ display: 'flex', gap: '1rem' }}>
                <Button
                  color="primary"
                  variant="outlined"
                  onClick={() => setIsEditMode(false)}>
                  Cancel
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleEditSave}>
                  Save
                </Button>
              </Box>
            ) : (
              <Button
                color="primary"
                variant="outlined"
                onClick={() => setIsEditMode(true)}>
                Edit
              </Button>
            )}
          </Box>

          <Box my={1} />

          <Box display={'flex'} my={2} style={{ gap: '1rem' }}>
            <Box sx={{ width: '500px', height: '100%' }}>
              <Typography fontWeight={'fontWeightMedium'}>
                Product Category : {data.plan.productCategory}
              </Typography>
              <Typography fontWeight={'fontWeightMedium'}>
                Products Access : {data.plan.products.join(', ')}
              </Typography>
              <Box my={2} />
              <Typography fontWeight={'fontWeightMedium'}>
                User : {data.user.name} - {data.user.email} -{' '}
                {/* {data.profile && data.profile.role}{' '} */}
                {data.school && `- ${data.school.name}`}
              </Typography>

              <Box my={2} />
              {isEditMode ? (
                <Box
                  style={{
                    display: 'flex',
                    gap: '1rem',
                    alignItems: 'center',
                  }}>
                  <Typography fontWeight={'fontWeightMedium'}>
                    Classes Access :{' '}
                  </Typography>
                  <Box width={200}>
                    <BuzzMultiSelect
                      valueKey="value"
                      labelKey="label"
                      options={classes.map(({ _id, name }) => {
                        return { label: name, value: _id };
                      })}
                      value={editFormFields.metadata.accessClassIds}
                      onChange={(e) => {
                        setFormData('metadata.accessClassIds', e.target.value);
                      }}
                    />
                  </Box>
                </Box>
              ) : (
                <Typography fontWeight={'fontWeightMedium'}>
                  Classes Access :{' '}
                  {data.accessClassIds.map(({ name }) => name).join(', ')}
                </Typography>
              )}

              <Box my={2} />
              {data.accessTeenybeansLanguages &&
                data.accessTeenybeansLanguages.length > 0 && (
                  <>
                    {isEditMode ? (
                      <Box
                        style={{
                          display: 'flex',
                          gap: '1rem',
                          alignItems: 'center',
                        }}>
                        <Typography fontWeight={'fontWeightMedium'}>
                          Teenybeans Languages :{' '}
                        </Typography>
                        <Box width={300}>
                          <BuzzMultiSelect
                            valueKey="value"
                            labelKey="label"
                            options={languages.map(({ _id, name }) => {
                              return { label: name, value: _id };
                            })}
                            value={
                              editFormFields.metadata
                                .accessTeenybeansLanguageIds
                            }
                            onChange={(e) => {
                              setFormData(
                                'metadata.accessTeenybeansLanguageIds',
                                e.target.value
                              );
                            }}
                          />
                        </Box>
                      </Box>
                    ) : (
                      <Typography fontWeight={'fontWeightMedium'}>
                        Teenybeans Languages Access :{' '}
                        {data.accessTeenybeansLanguages
                          .map(({ name }) => name)
                          .join(', ')}
                      </Typography>
                    )}
                  </>
                )}

              {data.metadata.teenybeansSessionStartMonth && (
                <>
                  {isEditMode ? (
                    <Box
                      style={{
                        display: 'flex',
                        gap: '1rem',
                        alignItems: 'center',
                      }}>
                      <Typography fontWeight={'fontWeightMedium'}>
                        Teenybeans Session Start Month :
                      </Typography>
                      <BuzzSelect
                        valueKey="value"
                        labelKey="label"
                        options={months.map((value) => {
                          return {
                            label: capitalize(value.toLowerCase()),
                            value,
                          };
                        })}
                        value={
                          editFormFields.metadata.teenybeansSessionStartMonth
                        }
                        onChange={(e) => {
                          setFormData(
                            'metadata.teenybeansSessionStartMonth',
                            e.target.value
                          );
                        }}
                      />
                    </Box>
                  ) : (
                    <Typography fontWeight={'fontWeightMedium'}>
                      Teenybeans Session Start Month :{' '}
                      {data.metadata.teenybeansSessionStartMonth}
                    </Typography>
                  )}
                </>
              )}

              <Box my={2} />
              {isEditMode ? (
                <Box
                  style={{
                    display: 'flex',
                    gap: '1rem',
                    alignItems: 'center',
                  }}>
                  <Typography fontWeight={'fontWeightMedium'}>
                    Start Date :
                  </Typography>
                  <BuzzInput
                    type="date"
                    value={moment(editFormFields.startDate).format(
                      'YYYY-MM-DD'
                    )}
                    onChange={(e) => {
                      setFormData('startDate', e.target.value);
                    }}
                  />
                </Box>
              ) : (
                <Typography fontWeight={'fontWeightMedium'}>
                  Start Date : {moment(data.startDate).format('DD MMM YYYY')}
                </Typography>
              )}

              {isEditMode ? (
                <Box
                  style={{
                    display: 'flex',
                    gap: '1rem',
                    alignItems: 'center',
                  }}>
                  <Typography fontWeight={'fontWeightMedium'}>
                    End Date :
                  </Typography>
                  <BuzzInput
                    type="date"
                    value={moment(editFormFields.endDate).format('YYYY-MM-DD')}
                    onChange={(e) => {
                      setFormData('endDate', e.target.value);
                    }}
                  />
                </Box>
              ) : (
                <Typography fontWeight={'fontWeightMedium'}>
                  End Date : {moment(data.endDate).format('DD MMM YYYY')}
                </Typography>
              )}
            </Box>
            <Box sx={{ width: '300px', height: '100%' }}>
              <Typography fontWeight={'fontWeightMedium'}>
                Consumed License Count:{' '}
                {data.metadata.consumedLicensesCount || 0}
              </Typography>
              <Box my={2} />
              <Typography fontWeight={'fontWeightMedium'}>
                Available Licenses
              </Typography>
              {availableLicenseQuota &&
                Object.entries(availableLicenseQuota).map(
                  ([key, value], idx) => (
                    <Typography fontWeight={'fontWeightMedium'} key={idx}>
                      <Box
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '1rem',
                          marginLeft: '1rem',
                        }}>
                        <p style={{ minWidth: '50px' }}>
                          {key}
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          {'= '}
                          {parseInt(value)}
                        </p>
                        {isEditMode && (
                          <Box
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}>
                            {addedLicenseQuota[key] >= 0 ? '+' : '- '}
                            &nbsp;&nbsp;
                            <input
                              type="number"
                              value={Math.abs(addedLicenseQuota[key])}
                              width={10}
                              onChange={(e) =>
                                changeLicenseCount(
                                  key,
                                  parseInt(e.target.value) >= 0
                                    ? parseInt(e.target.value)
                                    : 0
                                )
                              }
                              style={{
                                width: '30px',
                                height: '30px',
                                fontSize: '1rem',
                                padding: '0 0.5rem',
                              }}></input>
                            <Box
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}>
                              <Button
                                onClick={() => incrementLicenseCount(key)}
                                style={{ minWidth: '20px', padding: 0 }}>
                                <ArrowDropUp />
                              </Button>
                              <Button
                                onClick={() => decrementLicenseCount(key)}
                                style={{ minWidth: '20px', padding: 0 }}
                                disabled={
                                  Math.abs(addedLicenseQuota[key]) <= 0
                                }>
                                <ArrowDropDown />
                              </Button>
                            </Box>
                            &nbsp;&nbsp; = &nbsp;&nbsp;
                            {parseInt(value) + Math.abs(addedLicenseQuota[key])}
                          </Box>
                        )}
                      </Box>
                    </Typography>
                  )
                )}
            </Box>
          </Box>
          <Box my={1} style={{ display: 'flex', alignItems: 'center' }} />
        </Box>
      </>
    </Modal>
  );
}

export default SubscriptionModal;
